"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-layout-grid";
exports.CELL_BASE_CLASS_NAME = exports.BASE_CLASS_NAME + "__cell";
exports.MARGIN_CSS_VARIABLE = "--mdc-layout-grid-margin";
exports.GUTTER_CSS_VARIABLE = "--mdc-layout-grid-gutter";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/layout-grid/lib/constants.js
// module id = ./node_modules/@react-mdc/layout-grid/lib/constants.js
// module chunks = 1 2